import { NgModule } from '@angular/core';
import { HttpService } from './http.service';
import { ErrorHandlingService } from './error-handling.service';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandlingDirective } from './error-handling.directive';

@NgModule({
  imports: [HttpClientModule],
  declarations: [ErrorHandlingDirective],
  providers: [ErrorHandlingService, HttpService],
  exports: [ErrorHandlingDirective, HttpClientModule]
})
export class HttpModule {
}
